export default __webpack_public_path__ + "static/media/contact-detail.093590b1.jpg";